import api from ".";

export default async function getApartmentsWithUsers(towerId: number | string) {
  const response = await api.get(`/tower/getApartmentsWithUsers/${towerId}`);

  return response.data;
}
